import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import KLButton from '../../KLButton';
import { Wrapper, ErrorText } from './styles';

interface PhoneStepProps {
  onSubmit: (phone: string) => void;
  isSubmitting: boolean;
  error?: string;
}

const PhoneStep: React.FC<PhoneStepProps> = ({ onSubmit, isSubmitting, error }) => {
  const [phone, setPhone] = useState('');

  const handleSubmit = () => {
    if (phone.trim().length > 0) onSubmit(phone.trim());
  };

  return (
    <Wrapper>
      <TextField
        label="מספר טלפון"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        type="tel"
        autoComplete="tel"
        inputMode="tel"
        disabled={isSubmitting}
      />
      {error && <ErrorText role="alert">{error}</ErrorText>}
      <KLButton
        title="שלחו לי קוד"
        onClick={handleSubmit}
        disabled={isSubmitting || phone.trim().length === 0}
        loading={isSubmitting}
      />
    </Wrapper>
  );
};

export default PhoneStep;
